import script from "./DropZone.vue?vue&type=script&setup=true&lang=js"
export * from "./DropZone.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"DropZone.vue"]])

export default __exports__